import type { ReactElement } from 'react';

const ERROR_MESSAGE_CLASS =
  'mt-1 rounded-md px-2 py-1 bg-[var(--color-error-600)] text-white text-xs shadow-md';

/**
 * Save-failure pill rendered directly under an inline-edited field row —
 * shared by the task side panel's fields and the generic overview row so a
 * rejected save looks the same on every record surface.
 */
export function InlineFieldError({
  message,
}: {
  message: string | null;
}): ReactElement | null {
  if (!message) {
    return null;
  }
  return (
    <div role='alert' className={ERROR_MESSAGE_CLASS}>
      {message}
    </div>
  );
}
